import { CSSProperties } from 'react'
import { StyledLink } from './styled'

type TProps = {
  children: React.ReactElement
  href: string
  style?: CSSProperties
}

const Link = ({ children, href = '/', style = {} }: TProps) => (
  <StyledLink href={href} style={style}>
    {children}
  </StyledLink>
)

export default Link
